import React, { useEffect, useRef } from "react";
import { CareersView } from "./careersView";
import { useDispatch, useSelector } from "react-redux";
import { fetchJobListings } from "../../Infrastructure/States/jobListingsSlice";
import { Loader } from "../Common/Loader/loader";

const CareersContainer = () => {
  const dispatch = useDispatch()
  const listingsRef = useRef(null);
  const { jobsData, loading } = useSelector(state => state.jobs)
  const handleScroll = () => {
    if (listingsRef.current) { listingsRef.current?.scrollIntoView({ behavior: "smooth", block: 'start' }) }
  };

  useEffect(() => {
    dispatch(fetchJobListings())
  }, [dispatch])

  if (loading) {
    return <Loader height="100vh" />
  }

  return (
    <>
      <CareersView jobListings={jobsData} handleScroll={handleScroll} listingsRef={listingsRef} />
    </>
  );
};

export default CareersContainer;
